import VesselKpiOverview from '../components/overview/VesselKpiOverview';
import { useMemo } from 'react';
import SectorKpiOverview from '../components/overview/SectorKpiOverview';
import { useAppSelector } from '../../../core/rootHooks';
import { IKpiVessel } from '../kpiTypes';
import { selectSelectionData } from '../../search/searchSelectors';
import DynamicTab from '../../../shared/components/tabs/DynamicTab';

export interface IFleetKpiProps {
	selectedVessels: IKpiVessel[] | [];
}

const FleetKpi: React.FC<IFleetKpiProps> = ({ ...props }) => {
	const { selectionName } = useAppSelector(selectSelectionData);	

	const sectorData = useMemo(() => {
		const dataList = props.selectedVessels || [];
		const groupedData = dataList.reduce(
			(acc, item: IKpiVessel) => {
				const { sectorName, sectorId, imoNumber } = item;
				if (!acc[sectorId]) {
					acc[sectorId] = {
						sectorName,
						sectorId,
						imoList: [],
					};
				}
				acc[sectorId].imoList.push(imoNumber);
				return acc;
			},
			{} as Record<number, { sectorName: string; sectorId: number; imoList: number[] }>,
		);

		return Object.values(groupedData);
	}, [props.selectedVessels]);

	const sectorsTabs = () => {
		return sectorData.map((item) => {
			return {
				id: item.sectorId.toString(),
				label: item.sectorName,
				content: <SectorKpiOverview title={selectionName} sectorId={item.sectorId} imoList={item.imoList} />,
			};
		});
	};

	return (
		<DynamicTab
			key={'fleet-kpi'}
			dynamicItem={VesselKpiOverview}
			dynamicItemData={props.selectedVessels}
			dynamicItemProps={(item) => ({
				data: item,
				giveSpace: false,
				isFleet: true,
			})}
			staticItems={[
				<DynamicTab
					key={'fleet-kpi-sector'}
					items={sectorsTabs()}
					tabColor="msi-darkgrey-color"
					props={{ isVertical: true }}
					giveSpace={false}
					isSubtab
				/>,
			]}
			tabColor="msi-darkgrey-color"
			giveSpace
		/>
	);
};

export default FleetKpi;
